const geoCode = 268;

export { geoCode };
